import { Link } from "@quintype/components";
import React from "react";
import Cardimage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import "./story-card21.m.css";

const StoryCard21 = ({ story }) => {
  const { slug, headline } = story;
  return (
    <Link href={`/${slug}`}>
      <div styleName="wrapper" id="story-card-21">
        <div styleName="heading">
          <Headline text={headline} headerType={6} headerLevel={1} story={story} />
        </div>
        <Cardimage
          story={story}
          aspectRatio={[2, 1]}
          imageType="image2x1"
          widths={[400, 700]}
          sizes="(max-width: 1024px) 20vw, 100vw"
          showVideoIcon={true}
        />
      </div>
    </Link>
  );
};

export default StoryCard21;
